export default [
    {
        path: '/model/corpus',
        name: 'corpus',
        component: () => import("../views/datamodel/index.vue")
    },
    {
        path: '/model/match',
        name: 'matchModel',
        component: () => import("../views/datamodel/matchModel.vue")
    },
    {
        path: '/model/bigData',
        name: 'bigData',
        component: () => import("../views/datamodel/bigData.vue")
    },
    {
        path: '/model/dataRadar',
        name: 'dataRadar',
        component: () => import("../views/datamodel/dataRadar.vue")
    },
    {
        path: '/model/report',
        name: 'report',
        component: () => import("../views/datamodel/report.vue")
    },
    {
        path: '/model/oddsWave/details',
        name: 'oddsWaveDetails',
        component: () => import("../views/datamodel/oddsWaveDetails.vue")
    }
]
